<template>
  <v-container>
    <v-dialog v-model="dialog" v-if="itemToRemove" max-width="300">
      <v-card>
        <v-card-title>
          Remove checklist
          <v-icon color="warning">warning</v-icon>
        </v-card-title>
        <v-card-text>Do you want to remove {{ itemToRemove.name }}?</v-card-text>
        <v-card-actions>
          <v-container>
            <v-row>
              <v-col cols="6">
                <v-btn block @click="remove(itemToRemove)">Yes</v-btn>
              </v-col>
              <v-col cols="6">
                <v-btn block @click="dialog = false">Cancel</v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <CreateChecklistDialog :entity-id="itemId" @checklist-added="load" ref="checklistDialog"/>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-toolbar flat>
            <v-toolbar-title>Add/Edit Checklist</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn text @click.stop="addChecklist">
              <v-icon>add</v-icon> Add Checklist
            </v-btn>
          </v-toolbar>
          <v-card-text v-if="checklists.length > 0">
            <v-container>
              <v-row no-gutters>
                <v-col cols="12">
                  <v-list>
                    <template v-for="cl in checklists">
                      <v-list-item v-if="cl.status === 'draft'" :key="cl.name" @click.stop="edit(cl)">
                        <v-container>
                          <v-row>
                            <v-col cols="9">{{ cl.name }}</v-col>
                            <v-col cols="3">
                              <v-btn small @click.stop="submit(cl)" class="mr-2">Submit</v-btn>
                              <v-btn icon color="red lighten-3" @click.stop="confirmRemove(cl)"><v-icon>delete_outline</v-icon></v-btn>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-list-item>
                    </template>
                  </v-list>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12">
        <v-card>
          <v-card-title>Sumbitted checklists</v-card-title>
          <v-card-text>
            <v-container>
              <v-row no-gutters>
                <v-col cols="12" md="6">
                  <v-list>
                    <template v-for="cl in checklists">
                      <v-list-item v-if="cl.status !== 'draft'" :key="cl.name">
                        <span>{{ cl.name }}</span> <v-chip>{{ cl.status }}</v-chip>
                      </v-list-item>
                    </template>
                  </v-list>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import ChecklistService from '@/services/ChecklistService'
import CreateChecklistDialog from '@/components/dialog/CreateChecklistDialog'

const ChecklistModule = namespace('checklist')

@Component({
  components: {
    CreateChecklistDialog
  }
})
export default class ChecklistList extends Vue {
  @Prop(Number) itemId

  checklists = []
  dialog = false
  itemToRemove = null

  @ChecklistModule.Action setFieldItems

  load () {
    this.checklists = []
    ChecklistService.list(this.itemId)
      .then(resp => {
        this.checklists = resp.data.results || resp.data
      })
  }

  addChecklist () {
    this.$refs.checklistDialog.open()
  }

  edit (checklist) {
    this.$refs.checklistDialog.open(checklist)
  }

  confirmRemove (item) {
    this.itemToRemove = item
    this.dialog = true
  }

  remove (item) {
    ChecklistService.delete(item.id)
      .then(() => {
        this.load()
      })
  }

  submit (ckList) {
    this.setFieldItems({
      id: ckList.id,
      items: [{
        name: 'status',
        value: 'submitted'
      }]
    })
      .then(resp => {
        this.load()
      })
      .catch(err => {
        const message = err.response.data.detail
        this.$emit('update-checklist-error', {
          model: true,
          detail: `Submit failed, ${message}`,
          color: 'error'
        })
      })
  }
}
</script>
